
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import './Footer.css';

export default function Footer() {
  return (
    <>
     <footer className="footer">
  <div className="footer-container">
    <div className="footer-column">
      <h3>Quick Links</h3>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/About">About Us</Link></li>
        <li><Link to="/Contact">Contact</Link></li>
      </ul>
    </div>
    <div className="footer-column">
      <h3>Service Links</h3>
      <ul>
        <li><Link to="/WashingMachine">Washing Machine Service</Link></li>
        <li><Link to="/AcService">AC Service</Link></li>
        <li><Link to="/FridgeService">Fridge Service</Link></li>
      </ul>
    </div>
    <div className="footer-column">
      <h3>Contact</h3>
      <ul>
        <li>22A, Kumaran Colony,</li>
        <li>1st Street, Saidapet, Chennai-600015 (Bavani D/S)600088</li>
        <li>Phone: +919176849803</li>
      </ul>
    </div>
    <div className="footer-column">
      <h3>Our Location</h3>
      <div className="map-container">
        <iframe title="Chennai"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d248755.92960945363!2d79.89748266258087!3d13.047673788603051!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265ea4f7d3361%3A0x6e61a70b6863d433!2sChennai%2C%20Tamil%20Nadu%2C%20India!5e0!3m2!1sen!2sus!4v1730960735029!5m2!1sen!2sus"
          width="100%"
          height="150"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  </div>
  <div className="footer-bottom">
    <p>© 2024 Sri Hari Home Care. <Link to="/PrivacyPolicy">Privacy Policy</Link> | <Link to="/TermsConditions">Terms & Conditions</Link></p>
  </div>
</footer>

    </>
  );
}
